<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal size="lg" :visible="modal.show" :data="model" :title="$t('Mark item(s) Collected')" @show="onShow"
                   @hidden="onHidden" :content-in-form="false" :show-confirmation="showConfirmation"
                   :is-loading="loading" scrollable @ok.prevent="handleSubmit(onSubmit)">

      <table class="table table-sm">
        <tr>
          <th class="border-top-0">{{
              editObject && editObject.type === INVOICE_TYPE_MANUAL ? $t('Stock No.') : $t('Lot')
            }}
          </th>
          <th class="border-top-0">{{ $t('Title') }}</th>
          <th class="border-top-0">{{ $t('Quantity') }}</th>
          <th class="border-top-0">{{ $t('Collected') }}</th>
        </tr>
        <tr v-for="item in financialItems" :key="`row-create-${item.uuid}`">
          <td>{{ editObject && editObject.type === INVOICE_TYPE_MANUAL ? item.inventory.stock_no : item.lot_no }}</td>
          <td>{{ item.inventory.dynamic_fields | attributeByMasterLanguage('title') | striptags }}</td>
          <td>{{ item.quantity }}</td>
          <td>
            <input-widget :model="item" attribute="collected" type="checkbox" is-switch :label="false"
                          size="lg"/>
          </td>
        </tr>
      </table>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import ArtisioModal from "../../core/components/artisio-modal/ArtisioModal";
  import {createNamespacedHelpers} from "vuex";
  import InputWidget from "@/core/components/input-widget/InputWidget";
  import ReservationModel from "@/modules/inventory/Reservation.model";
  import {INVOICE_TYPE_MANUAL} from "@/modules/constants";
  import InvoicesService from "@/modules/invoices/InvoicesService";
  import LotsService from "@/modules/lots/LotsService";
  import helperService from "@/core/services/helper.service";


  const {mapState, mapActions} = createNamespacedHelpers('invoices');
  const {mapState: mapStateGlobal} = createNamespacedHelpers('global');

  export default {
    name: "MarkItemsCollectedModal",
    components: {
      ArtisioModal,
      InputWidget
    },
    data() {
      return {
        loading: false,
        showConfirmation: true,
        model: new ReservationModel(),
        financialItems: [],
        INVOICE_TYPE_MANUAL: INVOICE_TYPE_MANUAL
      }
    },
    computed: {
      ...mapStateGlobal(['enableInventoryQuantity']),
      ...mapState({
        modal: state => state.markItemsCollectedModal,
        editObject: state => state.markItemsCollectedModal.object,
      }),
    },
    watch: {
      editObject() {
        if (this.editObject && (this.editObject.uuid || this.editObject.type)) {
          if (this.editObject.type === INVOICE_TYPE_MANUAL) {
            this.financialItems = this.editObject.financial_items.map(item => new ReservationModel(item))
          } else {
            let tempFinancialItems = this.editObject.bidder.lots.filter(i => this.editObject.uuid === i.financial_item.invoice_uuid).map(
                item => {
                  let tempItem = new ReservationModel({
                    ...item,
                    collected: item.financial_item.collected
                  })
                  return tempItem
                }
            )
            this.financialItems = tempFinancialItems;
          }
        }
      }
    },
    methods: {
      ...mapActions(['hideMarkItemsCollectedModal', 'getTableData']),
      async onShow() {
        this.showConfirmation = true;
        this.loading = false;
      },
      onHidden() {
        this.hideMarkItemsCollectedModal();
      },
      async onSubmit() {
        this.loading = true;

        const reservation_proposals = (await LotsService.getLatestReservationProposals({
          invoice_uuids: [this.editObject.uuid],
          suggestions: ['reoffer'],
        })).body
        if (reservation_proposals.length) {
          const confirm = await helperService.showProposalsConfirmationModal(reservation_proposals, this.$confirm, this.$router, this.$options.filters)
          if (!confirm) {
            this.loading = false
            return
          }
        }

        let financialItems = this.financialItems.map(item => {
          return {
            uuid: this.editObject.type === INVOICE_TYPE_MANUAL ? item.uuid : item.financial_item.uuid,
            collected: item.collected
          }
        })

        let requestData = {
          invoice_uuid: this.editObject.uuid,
          financial_items: financialItems,
        }
        let response = await InvoicesService.markInvoiceItemsCollected(requestData)
        this.loading = false;

        if (response.success) {
          this.showConfirmation = false;
          this.$toast('success', this.$t('Invoice item(s) was successfully collected'));
          this.hideMarkItemsCollectedModal();
        } else {
          if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0]);
          } else {
            this.$toast('danger', this.$i18n.t('Something went wrong. Please try again.'))
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
